const WIDGET_SCRIPT_URL = 'https://cdn.pricespider.com/1/lib/ps-widget.js';
const WIDGET_SCRIPT_ID = 'nulo-price-spider-widget';
const UTID_SCRIPT_ID = 'nulo-price-slider';

/**
 * @extends {HTMLElement}
 */
class StoreLocator extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.#init();
  }

  disconnectedCallback() {
    this._initialized = false;
  }

  async #init() {
    const accountId = this.dataset.psAccountId || '6305';
    const utidScriptUrl = `https://cdn.pricespider.com/1/${accountId}/ps-utid.js`;

    await Promise.all([
      this.#loadScript(WIDGET_SCRIPT_ID, WIDGET_SCRIPT_URL),
      this.#loadScript(UTID_SCRIPT_ID, utidScriptUrl),
    ]);

    this.#rebindPriceSpider();
  }

  /**
   * @param {string} id
   * @param {string} url
   * @returns {Promise<void>}
   */
  #loadScript(id, url) {
    return new Promise((resolve) => {
      if (document.getElementById(id) || document.querySelector(`script[src="${url}"]`)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.id = id;
      script.src = url;
      script.async = true;
      script.addEventListener('load', () => resolve(), { once: true });
      script.addEventListener('error', () => resolve(), { once: true });
      document.head.appendChild(script);
    });
  }

  #rebindPriceSpider() {
    const rebind = () => {
      if (window.PriceSpider?.rebind) {
        window.PriceSpider.rebind();
      }
    };

    rebind();

    window.setTimeout(rebind, 2000);
  }
}

if (!customElements.get('store-locator')) {
  customElements.define('store-locator', StoreLocator);
}
